module.exports = __webpack_public_path__ + "static/media/applogo.4d85ca24.png";